export default __webpack_public_path__ + "static/media/404.528dc947.svg";